import React from 'react'
// TODO move ui
// import { Form, FormRow, Checkbox } from '@brainstud/schiphol-vtc-ui'

class Multiple extends React.Component {
  handleChange = e => {
    const value = e.target.value
    const name = e.target.name
    const answer = this.props.progress[name] || []

    const newValue = answer.indexOf(value) === -1
      ? answer.concat(value)
      : answer.filter(val => val !== value)

    this.props.onUpdate({
      [name]: newValue
    })
  }

  render() {
    return (
      <div style={{ pointerEvents: this.props.disabled ? 'none' : 'auto' }}>
        <Form>
          {this.props.answers.map(answer => (
            <FormRow key={answer.id}>
              <Checkbox
                name="answer"
                label={answer.label}
                value={answer.id}
                checked={this.props.progress.answer && this.props.progress.answer.indexOf(answer.id) !== -1}
                onChange={this.handleChange} />
            </FormRow>
          ))}
        </Form>
      </div>
    )
  }
}

export default Multiple
